import { AppHeader } from '../templates/AppHeader';
import { PageContent } from '../templates/PageContent';
import { Form } from '../templates/Form';
import { Button } from '../atoms/Button';
import { useContext, useEffect, useState } from 'react';
import LoadingModal from '../organisms/LoadingModal';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../commons/paths';
import MessageModal from 'organisms/u006/MessageModal';
import { AppFooter } from 'templates/AppFooter';
import { useGetUser } from 'hooks/u006/useGetUserHooks';
import { AppContext } from 'templates/AppContextProvider';
import { useDeleteUser } from 'hooks/u006/useDeleteUserHooks';
import { useAuth } from 'hooks/useAuth';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { TransitionButton } from 'atoms/TransitionButton';
import { DeleteConfirmDialog } from 'organisms/u006/DeleteConfirmDialog';

const ENTRY_HOST = process.env.REACT_APP_ENTRY_HOST;
const GLOBAL_ENTRY_HOST = process.env.REACT_APP_GLOBAL_ENTRY_HOST;

export function UserDelete() {
  const ctx = useContext(AppContext);
  const userId = ctx.userId;
  const isGlobal = ctx.isGlobal;

  const auth = useAuth();

  const [data, loading, err] = useGetUser(userId);
  const [deleteUser, loadingDelete] = useDeleteUser();

  const [modalMessage, setModalMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const nav = useNavigate();

  const [messageModalLinkList, setMessageModalLinkList] = useState<JSX.Element[]>();
  const [isOpenDeleteConfirmDialog, setIsOpenDeleteConfirmDialog] = useState<boolean>(false);
  const onOpenDeleteConfirmDialog = () => setIsOpenDeleteConfirmDialog(true);
  const onCloseDeleteConfirmDialog = () => setIsOpenDeleteConfirmDialog(false);

  const { t: tUserEditDelete } = useTranslationWithLang('userEditDelete');
  const { t: tMessage } = useTranslationWithLang('message');

  const logout = () => {
    auth.signOut();
    nav(PATHS.LOGIN);
  };

  useEffect(() => {
    if (err != null) {
      setModalMessage(tUserEditDelete('TU006_028'));
      setShowModal(true);
    }
  }, [err]);

  const closeModal = () => {
    setShowModal(false);
  };

  const handleDelete = () => {
    onCloseDeleteConfirmDialog();
    if (data == null) {
      return;
    }
    deleteUser({
      request: {
        id: data.user.id,
        applicant_revision: data.applicant_revision,
        user_info_revision: data.user_info_revision,
      },
      onSuccess: () => {
        setShowModal(true);
        setModalMessage(tUserEditDelete('TU006_027'));
        logout();
      },
      onError: (err) => {
        if (err.res && err.res.audition_info) {
          const auditionInfo = err.res.audition_info;
          const auditionTitleLinkList = auditionInfo.map((audition) => {
            return (
              <p>
                {audition.title} :{' '}
                <a
                  href={`${PATHS.AUDITION_INFO}/${audition.audition_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'var(--c-textinput-label)' }}
                >
                  {isGlobal ? GLOBAL_ENTRY_HOST : ENTRY_HOST}
                  {PATHS.AUDITION_INFO}/{audition.audition_id}
                </a>
              </p>
            );
          });
          setShowModal(true);
          setMessageModalLinkList(auditionTitleLinkList);
          setModalMessage(tMessage('MU006F0209W'));
        } else {
          setShowModal(true);
          setModalMessage(tMessage('MU006F0055E'));
        }
      },
    });
  };

  return (
    <>
      {loading || (loadingDelete && <LoadingModal />)}
      {showModal && (
        <MessageModal
          message={modalMessage}
          linkList={messageModalLinkList}
          closeLabel={tUserEditDelete('TU006_024')}
          onClose={closeModal}
        />
      )}
      <AppHeader />
      <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
        {tUserEditDelete('TU006_020')}
      </div>
      <PageContent>
        <Form title={tUserEditDelete('TU006_020')}>
          <p>
            {tUserEditDelete('TU006_021')}
            <br />
            <br />
            {tUserEditDelete('TU006_022')}
            <br />
            {tUserEditDelete('TU006_023')}
          </p>
          <div className={'flex justify-center items-center'}>
            <TransitionButton className="w-[10rem] mr-6" label={tUserEditDelete('TU006_025')} />
            <Button
              label={tUserEditDelete('TU006_026')}
              onClick={onOpenDeleteConfirmDialog}
              className="w-[10rem]"
            />
          </div>
        </Form>
      </PageContent>
      <DeleteConfirmDialog
        open={isOpenDeleteConfirmDialog}
        onOk={handleDelete}
        onClose={onCloseDeleteConfirmDialog}
      />
      <AppFooter />
    </>
  );
}
